import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '../error_boundary_v1';
import ProductsSearch from './search/products_search';

function TopLevelSearch({
                          query, algoliaAppId, algoliaSearchKey, indexName, displayContactAndInfo,
                        }) {
  return (
    <ErrorBoundary>
      <ProductsSearch
        query={query}
        algoliaAppId={algoliaAppId}
        algoliaSearchKey={algoliaSearchKey}
        indexName={indexName}
        displayContactAndInfo={displayContactAndInfo}
      />
    </ErrorBoundary>
  );
}

TopLevelSearch.propTypes = {
  query: PropTypes.string,
  algoliaAppId: PropTypes.string.isRequired,
  algoliaSearchKey: PropTypes.string.isRequired,
  indexName: PropTypes.string.isRequired,
  displayContactAndInfo: PropTypes.bool,
};

TopLevelSearch.defaultProps = {
  query: '',
  displayContactAndInfo: true,
};

export default TopLevelSearch;
